"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get GetCompanyBillingCalculatePurchaseTotalRequest () {
        return GetCompanyBillingCalculatePurchaseTotalRequest;
    },
    get PostCompanyBillingCancelCardRequest () {
        return PostCompanyBillingCancelCardRequest;
    },
    get PostCompanyBillingCreateAddSeatsPaymentIntentRequest () {
        return PostCompanyBillingCreateAddSeatsPaymentIntentRequest;
    },
    get PostCompanyBillingUpdateCardRequest () {
        return PostCompanyBillingUpdateCardRequest;
    }
});
const _zod = require("zod");
const PostCompanyBillingUpdateCardRequest = _zod.z.object({
    paymentMethodId: _zod.z.string()
});
const PostCompanyBillingCancelCardRequest = _zod.z.object({
    setupIntentId: _zod.z.string()
});
const PostCompanyBillingCreateAddSeatsPaymentIntentRequest = _zod.z.object({
    quantity: _zod.z.string(),
    totalAmount: _zod.z.string()
});
const GetCompanyBillingCalculatePurchaseTotalRequest = _zod.z.object({
    quantity: _zod.z.string()
});
